import React from 'react';

export class VideoPlayer extends React.Component {
	state = {
		/**
		 * 直出 HTML 的时候不渲染具体的播放器，
		 * 只有在前端执行的时候才渲染
		 * */
		ready: false,
	}

	render() {
		const { ready } = this.state;
		return (
			<div className="draft-video-player">
				{ ready && this.renderPlayer() }
			</div>
		);
	}

	renderPlayer() {
		const { videoPlatform, videoId } = this.props;
		if (videoPlatform !== 'qq' || !videoId || videoId.length !== 11) {
			return <div className="video-error-text">不支持的视频内容</div>;
		}
		const playerUrl = `//v.qq.com/iframe/txp/player.html?vid=${videoId}`
		return (
			<iframe
				src={playerUrl}
				className="player-frame"
				allowFullScreen
				frameBorder={0}
				width="100%"
				height="100%">
			</iframe>
		);
	}

	componentDidMount() {
		this.setState({ ready: true });
	}
}



// WEBPACK FOOTER //
// ./lib/components/VideoPlayer.jsx